const descriptionData = "As a coding instructor, I develop custom, project-based curriculum for computer science students and lead classes in both group and 1:1 settings. These projects often consist of creating games by using foundational computer science principles. Below is a selection of projects that I’ve developed and taught to students."

const lessonsData = [
    {
        name: "Python Terminal and Turtle Projects",
        link: "https://github.com/tpett20/Python-Lessons",
        classPrompt: "",
        image: "https://i.imgur.com/iRFTOUD.png",
        info: "A GitHub repo with a collection of project-based lessons that run in a terminal or with Python Turtle.",
        platform: "Python",
        concepts: "Conditional Logic, Data Structures, Variables, Loops"
    },
    {
        name: "Guess the Magic Number",
        link: "https://scratch.mit.edu/projects/920755443/",
        classPrompt: "",
        image: "https://i.imgur.com/u5XY6Jn.png",
        info: "A game that uses important, fundamental coding logic to compare a random (magic) number to a player's guess.",
        platform: "Scratch",
        concepts: "Conditional + Comparison Statements, Variables, Random Numbers"
    },
    {
        name: "Balloon Popper",
        link: "https://scratch.mit.edu/projects/914583795/",
        classPrompt: "https://docs.google.com/document/d/1vvBd5gcmlJpW2ircL1m-anH8WOFm0GCIl4NZL8WNqts/edit?usp=sharing",
        image: "https://i.imgur.com/3lHPHR5.png",
        info: "A project that I taught in a special format in which I asked the class to write code based on user story prompts.",
        platform: "Scratch",
        concepts: "Variables, Conditional Statements, X+Y Axis, Loops, Clones"
    },
    {
        name: "Count the Donuts",
        link: "https://scratch.mit.edu/projects/932485199/",
        classPrompt: "",
        image: "https://i.imgur.com/MMM2XO7.png",
        info: "A game that develops students' understanding of variables, random numbers, and loops.",
        platform: "Scratch",
        concepts: "Variables, Input, Comparison Statements, Random Numbers, Loops"
    }
]

export { descriptionData, lessonsData }